/**
 * Etiqueta "Personalizar uma joia": nasce aberta, encolhe depois do tempo
 * configurado e deixa só o diamante.
 *
 * Enfeite, não estrutura: sem este arquivo a etiqueta fica aberta, que é o
 * estado legível. O encolher é só uma classe de estado; quem desenha a
 * transição é o CSS da seção.
 */
class PersonalizeTag extends HTMLElement {
  connectedCallback() {
    const seconds = Number(this.dataset.seconds);
    if (!Number.isFinite(seconds) || seconds <= 0) return;

    // Quem pede menos movimento no sistema recebe o estado final direto, sem
    // a animação de encolher.
    const reduzido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduzido) {
      this.dataset.state = 'mini';
      return;
    }

    this.timer = window.setTimeout(() => {
      this.dataset.state = 'mini';
    }, seconds * 1000);
  }

  disconnectedCallback() {
    window.clearTimeout(this.timer);
  }
}

if (!customElements.get('personalize-tag')) {
  customElements.define('personalize-tag', PersonalizeTag);
}
